import { amplitudeService } from '@/models/amplitude-service.ts';
import { routerService } from '@/core';
import debounce from 'lodash/debounce';
/**
 * Fires `[Frontend] Feature Gate Hit` when a freemium user encounters a locked
 * feature. Debounced so rapid re-renders / re-opens of the same paywall don't
 * spam Amplitude. Aggregation and ranking by `feature` happen on Amplitude's
 * side — we only emit the raw encounter.
 */
const track = debounce((feature, page) => {
    amplitudeService.trackEvent('[Frontend] Feature Gate Hit', { feature, page });
}, 1000, { leading: true, trailing: false });
// Gates without an explicit feature report 'general'; the page tells them apart.
export function trackFeatureGateHit(feature) {
    var _a;
    const name = (_a = routerService.current.value) === null || _a === void 0 ? void 0 : _a.name;
    track(feature, typeof name === 'string' ? name : null);
}
